import Vue from 'vue';
import Roulette from '@/components/Roulette/Roulette.vue';
import ApiRequest from '@/tools/ApiRequest';
import EarnedGift from '@/components/EarnedGift/EarnedGift.vue';
import InstantGifts from '@/components/InstantGifts/InstantGifts.vue';
import LuckyNumber from '@/components/LuckyNumber/LuckyNumber.vue';
import RequestException from '@/tools/helpers/RequestException';

export default Vue.extend({
  name: 'luckyRoulette',
  components: {
    roulette: Roulette,
    'earned-gift': EarnedGift,
    'instant-gifts': InstantGifts,
    'lucky-number': LuckyNumber,
  },
  data: () => ({
    part: 'roulette' as 'roulette' | 'win' | 'luckyNumber',
    instantGifts: [
      {
        id: 1,
        src: require('@/assets/img/faca.png'),
      },
      {
        id: 2,
        src: require('@/assets/img/parafusadeira.png'),
      },
      {
        id: 3,
        src: require('@/assets/img/gasolina.png'),
      },
      {
        id: 4,
        src: require('@/assets/img/maleta.png'),
      },
      {
        id: 5,
        src: require('@/assets/img/cortador.png'),
      },
    ],
    earnedGift: {
      id: -1,
      title: '',
    },
    luckyNumber: '0',
    spinned: false,
  }),
  computed: {
    luckySpins(): number {
      return this.$store.getters.luckySpins;
    },
    earnedGiftImg(): any {
      let index = this.instantGifts.findIndex((el) => el.id === this.earnedGift.id);

      if (index === -1) {
        index = 0;
      }

      return this.instantGifts[index].src;
    },
    roulette(): Vue & { spinAll: (earnedGift?: number) => void } {
      return this.$refs.roulette as Vue & { spinAll: (earnedGift?: number) => void };
    },
  },
  methods: {
    spin(): void {
      if (!this.spinned) {
        this.spinned = true;
        ApiRequest.luckySpin()
          .then((response) => {
            this.$store.dispatch('subLuckySpins');
            this.luckyNumber = response.data.number_lucky;

            if (response.data.message === 'Ganhou') {
              this.earnedGift = response.data.brinde;
              this.roulette.spinAll(this.earnedGift.id);
            } else {
              this.roulette.spinAll();
            }

            setTimeout(() => {
              this.nextPart();
            }, 4500);
          })
          .catch((error) => new RequestException(error, this.$store, this.$router));
      }
    },
    nextPart(): void {
      switch (this.part) {
        case 'roulette':
          this.part = this.earnedGift.id !== -1 ? 'win' : 'luckyNumber';
          break;

        case 'win':
          this.part = 'luckyNumber';
          break;

        case 'luckyNumber':
          if (this.earnedGift.id !== -1) {
            this.$router.push('/');
          } else {
            this.reset();
          }
          break;
      }
    },
    reset(): void {
      this.earnedGift = {
        id: -1,
        title: '',
      };
      this.luckyNumber = '0';
      this.part = 'roulette';
      this.spinned = false;

      if (this.luckySpins <= 0) {
        this.$router.push('/');
      }
    },
  },
  created(): void {
    if (this.luckySpins <= 0) {
      this.$router.push('/');
    }
  },
  beforeCreate(): void {
    //
  },
});
